import { EcranSaisieClient } from '@innovpaie/openpaye-moteur/saisie-client-ui';
import { useParams } from 'react-router-dom';
import { APP_CONFIG } from '@/constants/app';

/**
 * La page que le client ouvre depuis le lien reçu par mail : sans compte, aux
 * couleurs de SON cabinet (la marque arrive avec le formulaire). L'écran est
 * celui du paquet commun — le même que chez HUP ; un ajustement s'y fait une
 * seule fois (décision Rose du 21/09/2026).
 */
export function PageSaisieClient() {
  const { secret = '' } = useParams();
  return <EcranSaisieClient baseUrl={APP_CONFIG.api.baseUrl} secret={secret} />;
}
